import { render, staticRenderFns } from "./MobileCommunityUnitBusinessNewsUpdate.vue?vue&type=template&id=109277de&"
import script from "./MobileCommunityUnitBusinessNewsUpdate.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityUnitBusinessNewsUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MobileCommunityUnitBusinessNewsUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports